import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useActiveCompanyStore } from 'stores/activeCompanyStore';
import {
  pathnameToCanonicalQuickPath,
  recordQuickLinkVisit,
} from 'utils/quickLinksRecentStorage';

/** Records canonical pathnames only (no query) for dashboard Quick Links ordering. */
export function useQuickLinksRecentRecorder(): void {
  const location = useLocation();
  const activeCompanyId = useActiveCompanyStore((s) => s.activeCompanyId);
  const isInitialized = useActiveCompanyStore((s) => s.isInitialized);
  const lastCanonicalRef = useRef<string | null>(null);

  useEffect(() => {
    lastCanonicalRef.current = null;
  }, [activeCompanyId]);

  useEffect(() => {
    if (!isInitialized || !activeCompanyId) return;

    const canonical = pathnameToCanonicalQuickPath(location.pathname);
    if (!canonical) return;

    if (lastCanonicalRef.current === canonical) return;
    lastCanonicalRef.current = canonical;

    recordQuickLinkVisit(activeCompanyId, location.pathname);
  }, [activeCompanyId, isInitialized, location.pathname]);
}
